import { render, staticRenderFns } from "./FormRadio.vue?vue&type=template&id=24f06bdc&scoped=true"
import script from "./FormRadio.js?vue&type=script&lang=js&external"
export * from "./FormRadio.js?vue&type=script&lang=js&external"
import style0 from "./FormRadio.scss?vue&type=style&index=0&id=24f06bdc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f06bdc",
  null
  
)

export default component.exports